// extracted by mini-css-extract-plugin
export default {"header":"PublicHeader_header__WRD2U","image":"PublicHeader_image__pByMc","canvas":"PublicHeader_canvas__Pig4d"};